import { render, staticRenderFns } from "./a-loading.vue?vue&type=template&id=4c4675b7&scoped=true"
import script from "./a-loading.vue?vue&type=script&lang=js"
export * from "./a-loading.vue?vue&type=script&lang=js"
import style0 from "./a-loading.vue?vue&type=style&index=0&id=4c4675b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4675b7",
  null
  
)

export default component.exports